import styles from './Loader.module.scss';

const Loader = () => {
  return (
    <section className={styles.loadingScreen}>
      <div className={styles.loadingScreen__inner}>
        <div className={`${styles.ball} ${styles.one}`} />
        <div className={`${styles.ball} ${styles.two}`} />
        <div className={`${styles.ball} ${styles.three}`} />
      </div>
    </section>
  );
};

export default Loader;
